<div class="op-plaid-terms" *transloco="let t">
	<div class="op-micro-font op-mb-20 op-dark-grey">
		<p class="policy" [innerHTML]="t('PLAID_CONNECT.youAgreePlaidAccess')"></p>
		<p class="policy" [innerHTML]="t('PLAID_CONNECT.reviewPlaidTerms')"></p>
	</div>
</div>
